import { notificationCreate } from '@/services/exchange/notifications.service'

export default {
	namespaced: true,
	state: {
		notificationsSaveStatus: 'init',
	},
	getters: {
		getNotificationsSaveStatusExchange(state) {
			return state.notificationsSaveStatus
		},
	},
	mutations: {
		NOTIFICATION_SAVE_STATUS(state, value) {
			state.notificationsSaveStatus = value
		},
	},
	actions: {
		async saveNewNotificationExchange({ commit }, params) {
			commit('NOTIFICATION_SAVE_STATUS', 'pending')
			try {
				const { data } = await notificationCreate(params)
				commit('NOTIFICATION_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('NOTIFICATION_SAVE_STATUS', 'init')
				throw error
			}
		},
	},
}
